module.exports = __webpack_public_path__ + "img/body-3.902a12e6.png";